module.exports = __webpack_public_path__ + "static/media/Vehicle Sale-amico 1.3f5855b8.svg";